import type {RefObject} from 'react';
import type {HistoryItem} from '@AiChat/ai-chat.types';

export interface ChatHistoryListProps {
  containerRef: RefObject<HTMLDivElement | null>;
}

export const HISTORY_FETCH_LIMIT = 20;

export interface ChatHistoryListGroupHeader {
  type: ChatHistoryDisplayType.HEADER;
  title: string;
}

export interface ChatHistoryListItem {
  type: ChatHistoryDisplayType.ITEM;
  data: HistoryItem;
}

export enum ChatHistoryDisplayType {
  HEADER = 'header',
  ITEM = 'item',
}

export type ChatHistoryListDisplayItem = ChatHistoryListGroupHeader | ChatHistoryListItem;
